import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { CurrentService } from '../../../services/current.service';
import { DatasService } from '../../../services/datas.service';
import { GTM } from 'src/app/services/gtm.service';
import { CONTEXT } from 'src/app/enum/context';

@Component({
  selector: 'ng-hbm-bdi-layout',
  templateUrl: './layout.component.html'
})
export class LayoutComponent implements OnInit {

  layouts: any;

  @Output() onComplete:EventEmitter<void> = new EventEmitter();
  
  constructor(public current:CurrentService, public datas:DatasService, private gtm: GTM) { }

  async ngOnInit(): Promise<void> {
    this.gtm.trackPage(CONTEXT.KITCHEN, 'need-mapping', 'layout', this.datas.getKitchenGtmData(this.current));
    this.layouts = await this.datas.getLayouts();
  }

  selectLayout(layoutId:string) {
    this.gtm.trackEvent('click', 'need-mapping', 'layout-' + layoutId);
    this.current.layoutRef = layoutId;
    this.onComplete.emit();
  }
}
